import { combineReducers } from 'redux';
import routing from './routing';
import quote from './quote';
import travelDetails from './travelDetails';
import payments from './payment';
import nextOfKin from './nextOfKin';
import payloadCollection from './payloadCollection';
import agent from './agent';

export const travelKe = combineReducers({
    routing,
    quote,
    travelDetails,
    payments,
    nextOfKin,
    payloadCollection,
    agent,
});
